var header_banner_section = ( function( $ ) {

	var $banner_section = null;

	var $carousel = null;

	var $search_inputs = null;

	var $search_button = null;

	var _init = function() {
		$banner_section = $( '#banner-section' );

		$carousel      = $banner_section.find( '.owl-carousel' );
		$search_inputs = $banner_section.find( '.header-banner-search-input' );
		$search_button = $banner_section.find( '.submit-search' );

		_set_loaded();
		_setup_slider();
		_setup_select2_fields();
		_setup_search();
		_setup_toggle_search();
	};

	var _set_loaded = function() {
		var $item = $carousel.find( '.item' );

		$item.addClass( 'loaded' );
	};

	var _setup_slider = function() {
		var $items = $carousel.find( '.item' );

		// Only init if more than one item
		if ( $items.length > 1 ) {
			$carousel.owlCarousel( {
				items: 1,
				margin: 500,
				stagePadding: 0,
				loop: true,
				slidesToShow: 1,
				autoplay: true,
				autoplayTimeout: 3000,
				autoplayHoverPause: true,
				animateOut: 'fadeOut',
				mouseDrag: false,
				touchDrag: false,
				freeDrag: false,
			} );
		}
	};

	var _setup_select2_fields = function() {
		if ( $search_inputs.length > 0 ) {
			$search_inputs.each( function() {
				var $this = $( this );

				$this.select2( {
					placeholder: $this.attr( 'data-placeholder' ),
				} );

				// Add class to select2 field so we can style inputs individually with CSS
				var $select2 = $this.next();

				$select2.addClass( 'select2-' + $this.attr( 'data-type' ) );
			} );

			$search_inputs.on( 'change', _on_select2_select );
		}
	};

	var _on_select2_select = function( e ) {
		$( '.select2-selection__choice' ).addClass( 'blue-select2-choice' );
	};

	var _setup_search = function() {
		if ( $search_button.length > 0 && $search_inputs.length > 0 ) {
			$search_button.on( 'click', _handle_search );
		}
	};

	var _handle_search = function( e ) {
		e.preventDefault();

		var search_data = [];

		$search_inputs.each( function() {
			var $this = $( this );

			var select2_data = $this.select2( 'data' );
			var key          = $this.attr( 'data-type' );

			search_data[ key ] = [];

			for ( let i = 0; i < select2_data.length; i++ ) {
				search_data[ key ].push( select2_data[ i ].id );
			}
		} );

		var url                = $search_button.data( 'search-url' );
		var begun_query_string = false;

		Object.keys( search_data ).forEach( function( key ) {
			if ( search_data[ key ].length > 0 ) {
				if ( begun_query_string ) {
					url += '&';
				} else {
					begun_query_string = true;
					url += '?';
				}

				url += `${ key }=`;

				for ( let i = 0; i < search_data[ key ].length; i++ ) {
					url += search_data[ key ][ i ];
					if ( i != search_data[ key ].length - 1 ) {
						url += ',';
					}
				}
			}
		} );

		window.location.href = url;
	};

	var _setup_toggle_search = function() {
		var $toggle = $banner_section.find( '.search-training-events-header' );

		if ( $toggle.length > 0 ) {
			$toggle.on( 'click', _toggle_search );
		}
	};

	var _toggle_search = function() {
		var $this = $( this );

		if ( $this.parent().hasClass( 'hide-responsive' ) && $( window ).width() < 992 ) {
			$this.parent().find( '.search-training-events-main' ).slideToggle();
			$this.toggleClass( 'toggled' );
		}
	};

	if ( $( '#banner-section' ).length > 0 ) {
		$( document ).ready( _init );
	}

	return {};

} )( jQuery );

module.exports = header_banner_section;